import { useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "../../config";

import { logout } from "../../redux/slices/auth";

const Logout = (props) => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  let history = useHistory();

  const logoutUser = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/users/logout`
      );
      if (response.status === 200) {
        dispatch(logout({}));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    logoutUser(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!user._id) {
      history.push("/");
    }
  }, [user, history]);

  return (
    <div>
      <h1>Logging out...</h1>
    </div>
  );
};

export default Logout;
